export default __webpack_public_path__ + "static/media/6.829264b7.jpg";